import { useEffect, useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { saveTenantSettings } from '../../services/catalog/supabaseCatalog'
import './PrintersPanel.css'

/**
 * "Fiş yazıcısı kullan" (28 Eki 2026, kullanıcı): bütün kurum için. Kapalıyken
 * hiçbir fiş basılmaz, yazdır düğmeleri gizlenir, kasada ana düğme Öde & Kapat
 * olur. Açıkken her şey varsayılan yazıcı ayarlarıyla, eskisi gibi.
 */
export function UsePrinterSwitch({ readOnly = false }: { readOnly?: boolean }) {
  const { tenantId, usePrinter } = useAuth()
  // Basınca hemen dönsün; kurum ayarı gelince onunla eşitleniyor.
  const [on, setOn] = useState(usePrinter)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => setOn(usePrinter), [usePrinter])

  const toggle = async () => {
    if (!tenantId || readOnly) return
    const next = !on
    setOn(next)
    setError(null)
    try {
      await saveTenantSettings(tenantId, { usePrinter: next })
    } catch (err) {
      console.error('[settings] use printer', err)
      setOn(!next)
      setError('Kaydedilemedi. İnternet bağlantınızı kontrol edin.')
    }
  }

  // .prn içinde: anahtarın stili (prn__switch) oraya bağlı, diğer anahtarlarla aynı görünsün.
  return (
    <div className="prn">
      <div className="setting">
        <div>
          <div className="setting__label">Fiş yazıcısı kullan</div>
          <div className="setting__hint">
            {on
              ? 'Fişler yazıcıdan basılır. Yazıcınız yoksa kapatın.'
              : 'Kapalı: hiçbir fiş basılmaz, yazdır düğmeleri gizli.'}
          </div>
        </div>
        <button
          type="button"
          className={`prn__switch ${on ? 'is-on' : ''}`}
          role="switch"
          aria-checked={on}
          aria-label="Fiş yazıcısı kullan"
          disabled={readOnly}
          onClick={() => void toggle()}
        >
          <span />
        </button>
      </div>
      {error && <p className="setting__error">{error}</p>}
    </div>
  )
}

/** Anahtar kapalıyken yazıcı ayarlarının yerinde duran açıklama. */
export function PrinterlessNote() {
  return (
    <div className="prnless" role="note">
      <strong>Yazıcısız çalışıyorsunuz</strong>
      <p>
        Satışı Öde &amp; Kapat ile kapatın, garson siparişleri mutfak ekranına düşer. Yazıcı
        aldığınızda anahtarı açmanız yeterli; yazıcı ayarları burada yeniden görünür.
      </p>
    </div>
  )
}
